<template>
  <settings-screen title="Backup">
    Backup settings will appear here!
  </settings-screen>
</template>

<script>
import SettingsScreen from '@/components/settings/SettingsScreen.vue';

export default {
  name: 'BackupSettings',
  components: {
    SettingsScreen,
  },
};
</script>
